module.exports = new __parcel__URL__("stem_resources.a8778212.png").toString();